import { useRef, useState } from "react";

export function useUaPhoneMask() {
  const PREFIX = "+380";
  const PREFIX_LEN = PREFIX.length;

  const inputRef = useRef(null);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const isPhoneValid = (value) => /^\+380\d{9}$/.test(value);

  const handlePhoneChange = (e) => {
    const raw = e.target.value || "";

    if (!raw) {
      setPhone("");
      setPhoneError("");
      return;
    }

    if (!raw.startsWith(PREFIX)) {
      const digits = raw.replace(/\D/g, "");

      if (digits.startsWith("380")) {
        setPhone(PREFIX + digits.slice(3, 12));
        return;
      }

      if (digits.startsWith("0")) {
        setPhone(PREFIX + digits.replace(/^0+/, "").slice(0, 9));
        return;
      }

      setPhone(PREFIX + digits.slice(0, 9));
      return;
    }

    const nat = raw.slice(PREFIX_LEN).replace(/\D/g, "").slice(0, 9);
    setPhone(PREFIX + nat);
  };

  const handlePhoneKeyDown = (e) => {
    const el = inputRef.current;
    if (!el) return;

    const start = el.selectionStart ?? 0;
    const end = el.selectionEnd ?? 0;

    if (
      (e.key === "Backspace" && start <= PREFIX_LEN) ||
      (e.key === "Delete" && start < PREFIX_LEN) ||
      ((e.key === "Backspace" || e.key === "Delete") &&
        start < PREFIX_LEN &&
        end > PREFIX_LEN)
    ) {
      e.preventDefault();
      setTimeout(() => el.setSelectionRange(PREFIX_LEN, PREFIX_LEN), 0);
    }
  };

  const handlePhoneFocus = () => {
    const el = inputRef.current;
    if (!el) return;

    if (!phone) {
      setPhone(PREFIX);
      setTimeout(() => el.setSelectionRange(PREFIX_LEN, PREFIX_LEN), 0);
    } else {
      setTimeout(() => {
        if ((el.selectionStart ?? 0) < PREFIX_LEN) {
          el.setSelectionRange(PREFIX_LEN, PREFIX_LEN);
        }
      }, 0);
    }
  };

  const handlePhoneBlur = () => {
    if (!phone || phone === PREFIX) {
      setPhone("");
      setPhoneError("Вкажіть телефон");
      return;
    }
    if (!isPhoneValid(phone)) {
      setPhoneError("Телефон має бути у форматі +380XXXXXXXXX");
    } else {
      setPhoneError("");
    }
  };

  return {
    phone,
    setPhone,
    phoneError,
    inputRef,
    isPhoneValid,
    handlers: {
      onChange: handlePhoneChange,
      onKeyDown: handlePhoneKeyDown,
      onFocus: handlePhoneFocus,
      onBlur: handlePhoneBlur,
    },
  };
}
